import React from "react";
import {
     MainLeftTitle,
    
} from "../../../_uiComponents/WrapperComponents";
import DataUpload from "./DataUpload";


function DataTableWrapper() {
     return (
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Sales Data Upload"/>
                    
                <DataUpload/>
          </div>
     );
}

export default DataTableWrapper;